import React from 'react';
import { useTranslate, linkToRecord } from 'ra-core';
import { Link } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import AppsIcon from '@material-ui/icons/Apps';
import TimeIcon from '@material-ui/icons/AccessTime';
import EventIcon from '@material-ui/icons/Event';
import format from 'date-fns/format';
import { MarkdownView, Stats, StatsText } from '../ui';
import { TagsField } from './TagsField';
import { ApiStatus } from './ApiStatus';
export const ApiCard = ({ basePath, record }) => {
    const classes = useStyles();
    const translate = useTranslate();
    const formattedDate = record && record.modifyTs ? format(record.modifyTs, 'P') : '';
    return (React.createElement(Card, { className: classes.root, component: Link, to: linkToRecord(basePath, record && record.id, 'show') },
        React.createElement(CardHeader, { className: classes.header, title: React.createElement(Tooltip, { title: record.name },
                React.createElement(Typography, { variant: "h5", component: "span", display: "block", className: classes.title, noWrap: true }, record.name)), disableTypography: true, subheader: React.createElement(React.Fragment, null,
                React.createElement("div", { className: classes.subheader },
                    React.createElement(ApiStatus, { record: record, variant: "caption" }),
                    React.createElement(Divider, { orientation: "vertical", className: classes.divider }),
                    React.createElement(Typography, { variant: "caption", color: "textSecondary", className: classes.ssgServiceType }, record.ssgServiceType),
                    React.createElement(Divider, { orientation: "vertical", className: classes.divider }),
                    React.createElement(Tooltip, { title: record.version },
                        React.createElement(Typography, { variant: "caption", color: "textSecondary", noWrap: true }, translate('resources.apis.list.cards.fields.version', {
                            version: record.version,
                        }))))) }),
        React.createElement(CardContent, { className: classes.content },
            React.createElement(Tooltip, { title: record.description || '' },
                React.createElement(MarkdownView, { className: classes.description, value: record.description }))),
        React.createElement(CardActions, { className: classes.footer },
            React.createElement(Grid, { container: true, alignItems: "center", className: classes.tags },
                React.createElement(TagsField, { record: record, source: "tags", className: classes.tag })),
            React.createElement(Grid, { container: true, alignItems: "center", className: classes.stats },
                React.createElement(Grid, { item: true },
                    React.createElement(Stats, { icon: React.createElement(AppsIcon, null), title: translate('resources.apis.list.cards.fields.applications_long', {
                            smart_count: record.applicationUsage || 0,
                        }) },
                        React.createElement(StatsText, null, translate('resources.apis.list.cards.fields.applications', {
                            smart_count: record.applicationUsage || 0,
                        })))),
                React.createElement(Grid, { item: true },
                    React.createElement(Stats, { icon: React.createElement(TimeIcon, null), title: translate('resources.apis.list.cards.fields.averageLatency_long', {
                            smart_count: record.averageLatency || 0,
                        }) },
                        React.createElement(StatsText, null, translate('resources.apis.list.cards.fields.averageLatency', {
                            ms: record.averageLatency || 0,
                        })))),
                formattedDate && (React.createElement(Grid, { item: true },
                    React.createElement(Stats, { icon: React.createElement(EventIcon, null), title: translate('resources.apis.list.cards.fields.updated', {
                            date: formattedDate,
                        }) },
                        React.createElement(StatsText, null, formattedDate))))))));
};
const useStyles = makeStyles(theme => ({
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
        textDecoration: 'none',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    },
    header: {
        borderBottomColor: theme.palette.divider,
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
    },
    title: {
        fontFamily: theme.typography.subtitle2.fontFamily,
        fontSize: theme.typography.subtitle2.fontSize,
        fontWeight: theme.typography.fontWeightBold,
        wordBreak: 'break-word',
        maxWidth: '100%',
    },
    subheader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        fontFamily: theme.typography.body2.fontFamily,
        fontSize: theme.typography.caption.fontSize,
        padding: theme.spacing(1, 0),
    },
    footer: {
        display: 'flex',
        flexDirection: 'column',
        flex: 0,
    },
    description: {
        flex: 1,
        overflow: 'hidden',
        // NOTE: We use some deprecated CSS props here but they are still well supported.
        // Besides, a new draft specification exists https://www.w3.org/TR/css-overflow-3/#propdef--webkit-line-clamp
        lineClamp: 3,
        boxOrient: 'vertical',
        display: '-webkit-box',
    },
    ssgServiceType: {
        fontWeight: theme.typography.fontWeightBold,
    },
    divider: {
        marginLeft: theme.spacing(),
        marginRight: theme.spacing(),
        minHeight: theme.spacing(2),
    },
    contentDivider: {
        width: '100%',
        marginBottom: theme.spacing(),
        marginTop: 0,
    },
    stats: {
        marginTop: 'auto',
    },
    tags: {
        borderTopStyle: 'solid',
        borderTopWidth: '1px',
        borderTopColor: theme.palette.grey[400],
        minHeight: theme.spacing(4),
        marginBottom: theme.spacing(1),
    },
    tag: {
        borderRadius: theme.spacing(0.5),
        fontWeight: theme.typography.fontWeightBold,
        '& + &': {
            marginLeft: theme.spacing(0.5),
        },
    },
}), {
    name: 'Layer7ApiCard',
});
//# sourceMappingURL=ApiCard.js.map